import type { VariantProps } from "class-variance-authority";
import type { ctaVariants } from "hec/components/ui/link-render";
import { LinkRender } from "hec/components/ui/link-render";

import { cn } from "~/lib/utils";

import type { CoreButtonProps } from "../utils";
import { appendSearchParams, buttonFunctions } from "../utils";
import { conditionComponentsMap, conditionOptionsMap } from "./utils";

type ButtonVariantProps = VariantProps<typeof ctaVariants>;

export interface ToggleTextButtonProps extends CoreButtonProps {
  condition: string;
  conditionMetText: string;
  conditionNotMetText: string;
  stateToShowInEditor: string;
  disabled?: boolean;
  variant?: ButtonVariantProps["variant"];
  isEdit: boolean;
  className?: string;
  [key: string]: any; // For ...props
}

export const ToggleTextButton = ({
  condition,
  conditionMetText,
  conditionNotMetText,
  stateToShowInEditor,
  disabled,
  variant,
  openInNewTab,
  clickFunction = buttonFunctions.linkToPage,
  scrollTargetId,
  queryParams,
  routeType,
  url,
  isEdit,
  className,
  isRevShare,
  ...props
}: ToggleTextButtonProps) => {
  let ButtonText;
  switch (condition) {
    case conditionOptionsMap.ACTIVE_GOAL:
      ButtonText = conditionComponentsMap[conditionOptionsMap.ACTIVE_GOAL];
      break;
  }
  const hrefValue = appendSearchParams({
    url,
    queryParamData: queryParams,
    clickFunction,
    scrollTargetId,
  });

  const buttonProps = {
    ctaType: "button" as const,
    disabled,
    variant,
    routeType,
    hrefValue,
    openInNewTab,
    asChild: true,
    className: cn(className, isRevShare && "rev-share"),
    ...props,
    "data-testid": props["data-testid"] || "toggleTextButton",
  };

  return (
    <LinkRender {...buttonProps}>
      {ButtonText && (
        <ButtonText
          conditionMetText={conditionMetText}
          conditionNotMetText={conditionNotMetText}
          stateToShowInEditor={stateToShowInEditor}
          isEdit={isEdit}
          data-testid="toggleTextButton-ButtonText"
        />
      )}
    </LinkRender>
  );
};
